import { Title } from "components/Title/Title"
import cls from "./DefaultPage.module.scss"
import linkedIn from "shared/assets/icons/LinkedIn-logo.webp"
import telegram from "shared/assets/icons/telegram-logo.png"
import vk from "shared/assets/icons/vk-logo.png"
import habr from "shared/assets/icons/habr-logo.png"

export const DefaultPage = () => {

    const onRedirect = (url: string) => {
        window.open(url)
    }

    return (
        <>
            <Title />
            <div className={cls.linksContainer}>
                <div onClick={() => onRedirect('https://www.linkedin.com/in/matvey770/')} className={cls.item}>
                    <img className={cls.icon} src={linkedIn} alt="icon"></img>
                </div>
                <div onClick={() => onRedirect('https://t.me/Freeze771')} className={cls.item}>
                    <img className={cls.icon} src={telegram} alt="icon"></img>
                </div>
                <div onClick={() => onRedirect('https://vk.com/fre_eze')} className={cls.item}>
                    <img className={cls.icon} src={vk} alt="icon"></img>
                </div>
                <div onClick={() => onRedirect('https://career.habr.com/matvey770')} className={cls.item}>
                    <img className={cls.icon} src={habr} alt="icon"></img>
                </div>
            </div>
        </>
    )
}